import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { useSelector } from "react-redux";

// Register Chart.js components and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler // Register Filler
);

const RainfallLineChart = ({ historicData }) => {
  const { theme } = useSelector((store) => store.dashboard)
  ChartJS.defaults.borderColor = theme === 'light' ? "#E2E8F0" : '#1E293B'; // Set the default line color

  // console.log('forecastData RAINFALL:', forecastData)
  // Extract dates and rainfall data
  const dates = historicData.map((item) => {
    const dateObj = new Date(item.Date_time);
    const options = { month: "short", day: "numeric" };
    return dateObj.toLocaleDateString("en-US", options);
  });

  // const rainfall = forecastData.map((item) => item.Rainfall);
  const rainfall = historicData.map((item) => item.Rainfall < 1 ? 0 : item.Rainfall.toFixed(2));
  const days = dates.length;

  // Chart data configuration
  const data = {
    // console.log('data:', data)
    labels: dates,

    datasets: [
      {
        label: "Rainfall (mm)",
        data: rainfall,

        borderColor: "rgba(13, 148, 136, 1)", // Emerald/teal line color
        backgroundColor: "rgba(13, 148, 136, 0.15)", // Fill color
        borderWidth: 2,
        tension: 0.4, // Smooth curve
        fill: true, // Enable filling under the line
      },
    ],
  };

  // Chart options configuration
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        title: {
          display: true,
          text: "Rainfall (mm)",
          color: theme === 'light' ? "#475569" : '#94A3B8',
        },
        ticks: {
          color: theme === 'light' ? "#64748B" : '#94A3B8'
        }
      },
      x: {
        grid: {
          color: theme === 'light' ? "rgba(15, 23, 42, 0.06)" : "rgba(248, 250, 252, 0.06)",
        },
        ticks: {
          color: theme === 'light' ? "#64748B" : '#94A3B8'
        },
        title: {
          display: true,
          text: "Date",
          color: theme === 'light' ? "#475569" : '#94A3B8'
        },
      },
    },
    plugins: {
      legend: {

        display: true,
        labels: {
          color: theme === 'light' ? "#475569" : '#94A3B8',

          font: {
            size: 12,
            weight: "500",
          },
        },
      },
      title: {
        display: true,
        text: ` ${days} Days Rainfall Historical Data`,
        color: theme === 'light' ? "#0F172A" : '#F8FAFC',

        font: {
          size: 16,
          weight: "bold",
        },
      },
    },
  };

  return (
    <div className="h-full w-full">
      <Bar data={data} options={options} />
    </div>
  );
};

export default RainfallLineChart;
